module.exports = __webpack_public_path__ + "img/ic_followup_console.f35308d8.svg";